<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="modal-company"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title !tw-text-purple-300">
          {{ 'COMPANY_TRADING_NEW' | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-help-menu [isSmallIcon]="true" class="tw-mt-2"></gk-help-menu>
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
    </div>
    <gk-company-form-v2 [company]="company"></gk-company-form-v2>
    <footer class="toolbar">
      <div class="toolbar__section toolbar__section--right">
        <gk-icon-button
          type="submit"
          btnType="square-fill"
          icon="check"
          size="compact"
          data-at="button-save"
          (buttonClick)="saveCompany()"
          gkStandardUser
        >
        </gk-icon-button>
      </div>
    </footer>
  </div>
</div>
